import z from "zod";

export const returnUrlSearchSchema = z.object({
  returnUrl: z.string().optional(),
});

export type ReturnUrlSearch = z.infer<typeof returnUrlSearchSchema>;
